const o = (r) => {
  const e = /^#(?:(?:[\da-f]{3}){1,2}|(?:[\da-f]{4}){1,2})$/i;
  return !!(r != null && r.replaceAll(" ", "").match(e));
};
export {
  o as isHexaColor
};
